export const RegisterForm = {
  identifier: 'ACCOUNT_CREATION',
  fields: [
    {
      name: 'title',
      type: 'LIST',
      required: true,
      confirmable: false,
      validators: [],
      options: ['Mr.', 'Mrs.', 'Other', 'Prefer not to say'],
      defaultValue: null,
      __typename: 'Field',
    },
    {
      name: 'fullName',
      type: 'TEXT',
      required: true,
      confirmable: false,
      validators: [
        {
          name: 'MIN_LENGTH',
          argument: 10,
          __typename: 'Validator',
        },
      ],
      options: [],
      defaultValue: null,
      __typename: 'Field',
    },
    {
      name: 'email',
      type: 'EMAIL',
      required: true,
      confirmable: true,
      validators: [
        {
          name: 'MIN_LENGTH',
          argument: 10,
          __typename: 'Validator',
        },
      ],
      options: [],
      defaultValue: null,
      __typename: 'Field',
    },
    {
      name: 'password',
      type: 'PASSWORD',
      required: true,
      confirmable: true,
      validators: [
        {
          name: 'MIN_LENGTH',
          argument: 10,
          __typename: 'Validator',
        },
      ],
      options: [],
      defaultValue: null,
      __typename: 'Field',
    },
    {
      name: 'phoneNumber',
      type: 'TEL',
      required: false,
      confirmable: false,
      validators: [],
      options: [],
      defaultValue: null,
      __typename: 'Field',
    },
    {
      name: 'referrerCode',
      type: 'TEXT',
      required: false,
      confirmable: false,
      validators: [],
      options: [],
      defaultValue: null,
      __typename: 'Field',
    },
    {
      name: 'marketingConsent',
      type: 'MARKETING_CONSENT',
      required: true,
      confirmable: false,
      validators: [],
      options: [
        'I_CONSENT_TO_RECEIVING_MARKETING_MATERIAL',
        'I_DO_NOT_CONSENT_TO_RECEIVING_MARKETING_MATERIAL',
      ],
      defaultValue: null,
      __typename: 'Field',
    },
    {
      name: 'loyaltyOptIn',
      type: 'BOOLEAN',
      required: false,
      confirmable: false,
      validators: [],
      options: null,
      defaultValue: true,
      __typename: 'Field',
    },
  ],
  __typename: 'Form',
}

const AccountSettingsForm = {
  identifier: 'ACCOUNT_SETTINGS',
  fields: [
    {
      name: 'fullName',
      type: 'TEXT',
      validators: [
        {
          name: 'MAX_LENGTH',
          argument: '64',
          __typename: 'Validator',
        },
        {
          name: 'MIN_LENGTH',
          argument: '1',
          __typename: 'Validator',
        },
        {
          name: 'NO_DIGITS',
          argument: null,
          __typename: 'Validator',
        },
        {
          name: 'NO_SPECIAL_CHARACTERS',
          argument: null,
          __typename: 'Validator',
        },
      ],
      required: true,
      confirmable: false,
      answerOptions: null,
      defaultValue: null,
      __typename: 'Field',
    },
    {
      name: 'phoneNumber',
      type: 'PHONE_NUMBER',
      validators: [
        {
          name: 'MAX_LENGTH',
          argument: '52',
          __typename: 'Validator',
        },
        {
          name: 'REGEX_MATCHES',
          argument: '^[0123456789 ()\\+]+$',
          __typename: 'Validator',
        },
      ],
      required: false,
      confirmable: false,
      answerOptions: null,
      defaultValue: null,
      __typename: 'Field',
    },
  ],
  __typename: 'Form',
}

export const form = (input) => {
  switch (input) {
    case 'ACCOUNT_CREATION':
      return RegisterForm
    case 'ACCOUNT_SETTINGS':
      return AccountSettingsForm
    default:
      return null
  }
}
